import {FETCH_VACANCIES_REQUEST, FETCH_VACANCIES_SUCCES, FETCH_VACANCIES_ERROR} from '../constants/Vacancies'
import { jsonGet, errorHandler } from '../utils/Request';

const loadVacancies = (filter, clear) => (dispatch, getState) => {
  // console.log('filter',filter);
  let currentFilter = "";
  let showCity = true;
  let popular = false;
  if (filter) {
    if (filter === 'popular') {
      popular = true;
    } else {
      currentFilter = "?";
      for (let value in filter) {
        let id = filter[value].id;
        currentFilter += (id && id !== '' && !Array.isArray(id)) ? `&${value}=${id}` : ''
        // для масивов (мультигорода)
        if (Array.isArray(id)){
          if (id.length <= 1) {
            showCity = false;
          } else {
            showCity = true;
          }
          let cities = "";
          for (let city of id) {
            cities += city.id ? `${city.id},` : ''
          }
          cities = cities.substring(0, cities.length - 1);
          currentFilter += (cities && cities !== '') ? `&${value}=${cities}` : ''
        }
      }
    }
  }

  const next = getState && getState().vacancies.next;
  const filterLink = `/vacancy/list/${currentFilter ? currentFilter : '' }`;
  const apiUrl = popular ? '/vacancy/list/?is_popular=true' :
                 clear ? filterLink :
                 next ? `${next}` :
                 `/vacancy/list/${currentFilter ? currentFilter : '' }`;

  dispatch({
    type: FETCH_VACANCIES_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      // console.log(json)
      dispatch({
        type: FETCH_VACANCIES_SUCCES,
        payload: json,
        concated: clear ? false : true,
        showCity: showCity ? true : false
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_VACANCIES_ERROR
      });
      errorHandler(e);
    });
};

export { loadVacancies };



// WEBPACK FOOTER //
// ./src/actions/VacanciesActions.js